import { Device } from '@capacitor/device'

// 환경별 엔드포인트 세트. 새 환경을 추가할 땐 여기에 항목만 더하면 된다.
// mqttTargetPath 는 command-center MQTT broker (wss) — mirrors chekt-web-monitoring-v2.
const ENV_CONFIG = {
  dev: {
    authClientID: 'yeJIohNks41mYAiaID29JoxsZESOpEQ8',
    authApiPath: 'https://auth.chektdev.com',
    authApiPathLegacy: 'https://chektdev.auth0.com',
    authDomain: 'auth.chektdev.com',
    authCookieDomain: '.chektdev.com',
    authTargetPath: 'account.chektdev.com',
    authAudience: 'https://api.chektdev.com',
    apiPath: 'https://api.chektdev.com',
    mqttTargetPath: 'commandcenter.chektdev.com',
  },
  qe: {
    // TODO(QE): Auth0 QE 테넌트에서 아래 두 값 확인 필요.
    //  - authClientID: monitoring-v2 / web-console 이 QE 에서 공용으로 쓰는 값
    //  - authApiPath / authApiPathLegacy: 커스텀 도메인(auth.chektqe.com) 사용 가능 여부
    authClientID: 'M2aHNcb8wnHqOGIvd7GpuZ8brfytFhWP',
    authApiPath: 'https://auth.chektqe.com',
    authApiPathLegacy: 'https://chektqe.us.auth0.com',
    authDomain: 'auth.chektqe.com',
    authCookieDomain: '.chektqe.com',
    authTargetPath: 'account.chektqe.com',
    authAudience: 'https://api.chektqe.com',
    apiPath: 'https://api.chektqe.com',
    mqttTargetPath: 'commandcenter.chektqe.com',
  },
  prod: {
    authClientID: 'bHzjpwmWpjwdOukz2h7FM2u2ND5BPKFa',
    authApiPath: 'https://auth.chekt.com',
    authApiPathLegacy: 'https://chektcloud.auth0.com',
    authDomain: 'auth.chekt.com',
    authCookieDomain: '.chekt.com',
    authTargetPath: 'account.chekt.com',
    authAudience: 'https://api.chekt.com',
    apiPath: 'https://api.chekt.com',
    mqttTargetPath: 'commandcenter.chekt.com',
  },
}

// 로컬 테스트용 환경 고정 스위치.
// 이 값 하나만 바꾸면 호스트/채널 판정을 무시하고 전체 환경이 바뀐다.
// '' (자동 판정) | 'dev' | 'qe' | 'prod'
const ENV_OVERRIDE = ''

// 실수로 커밋된 ENV_OVERRIDE 가 운영 환경을 바꾸지 못하게 막는다.
// chekt.com / chekt.name 에서 서비스 중이거나(웹), prod 로 판정된 채널이면(앱) 무시한다.
const isProductionContext = function (requestedEnv) {
  if (requestedEnv === 'prod') return true
  const host = (typeof location !== 'undefined' && location.hostname) || ''
  return /(^|\.)chekt\.(com|name)$/.test(host)
}

// 모든 환경이 공유하는 값
const ENV_COMMON = {
  authConnection: 'Username-Password-Authentication',
  authScope: 'openid offline_access',
  mqttTargetPathPort: 443,
}

const EnvironmentPlugin = {
  install (Vue) {
    let environment = {
      origin: null,
      authClientID: null,
      authDomain: null,
      authApiPath: null,
      authApiPathLegacy: null,
      authConnection: null,
      authAudience: null,
      authScope: null,
      authCookieDomain: null,
      authTargetPath: null,
      apiPath: null,
      mqttTargetPath: null,
      mqttTargetPathPort: 443,
      googleMapAPIKey: 'AIzaSyD33CRqwF-fO7Z9NioI9z98h0eDZ1la3cw', // Web
      deviceInfo: {},
      envName: 'dev',
      isProduction: false,
      isQe: false,
      updateEnvironment: function (env) {
        // 하위 호환: 기존 호출부가 boolean(isProd)을 넘기는 경우를 계속 지원한다
        if (typeof env === 'boolean') env = env ? 'prod' : 'dev'
        // ENV_OVERRIDE 가 켜져 있으면 호출부 판정보다 우선한다 (운영 컨텍스트는 예외)
        if (ENV_OVERRIDE) {
          if (isProductionContext(env)) {
            console.warn(`[env] ENV_OVERRIDE '${ENV_OVERRIDE}' is ignored in production context`)
          } else {
            console.warn(`[env] ENV_OVERRIDE is on: forcing '${ENV_OVERRIDE}' (requested: '${env}')`)
            env = ENV_OVERRIDE
          }
        }
        const key = ENV_CONFIG[env] ? env : 'dev'
        // console.log('updateEnvironment: ' + key)
        this.envName = key
        this.isProduction = key === 'prod'
        this.isQe = key === 'qe'
        Object.assign(this, ENV_COMMON, ENV_CONFIG[key])
      },
    }

    // UPDATE - ENV to default - DEV
    // 환경을 바꿔서 테스트하려면 위쪽 ENV_OVERRIDE 값을 수정한다
    environment.updateEnvironment('dev')

    // UPDATE - deviceInfo
    let updateDeviceInfo = async function () {
      let deviceInfo = await Device.getInfo()
      environment.deviceInfo = deviceInfo
      switch (deviceInfo.platform) {
      case 'web':
        // environment.googleMapAPIKey = 'AIzaSyD33CRqwF-fO7Z9NioI9z98h0eDZ1la3cw' // web
        // e.g. http://localhost:8100
        environment.origin = window.location.origin
        break
      case 'android':
        environment.googleMapAPIKey = 'AIzaSyC0-KFzE-EpdSWNNS8VsXxZhDQhXkjVkHs' // android
        // e.g. com.chekt.app.v3:/
        // ---->com.chekt.app.v3://callback
        // e.g. capacitor://localhost:8100/callback
        environment.origin = 'com.chekt.app.v3:/'
        environment.origin = 'capacitor://localhost'
        break
      case 'ios':
        environment.googleMapAPIKey = 'AIzaSyCye-2kL50E2zh_jbMU5ZbrP59ilk6XrF4' // ios
        // e.g. com.chekt.app.v3:/
        // ---->com.chekt.app.v3://callback
        // e.g. capacitor://localhost:8100/callback
        environment.origin = 'com.chekt.app.v3:/'
        environment.origin = 'capacitor://localhost'
        break
      default:
        // e.g. com.chekt.app.v3:/
        // ---->com.chekt.app.v3://callback
        // e.g. capacitor://localhost:8100/callback
        environment.origin = 'com.chekt.app.v3:/'
        environment.origin = 'capacitor://localhost'
        break
      }
    }
    updateDeviceInfo()
    
    Vue.prototype.$env = environment
    Vue.env = environment
  }
}

export default EnvironmentPlugin
